<section class="navitems">
<ul>
    <li>
        <a class="" routerLink="/home">Home</a>
        <a class="" routerLink="/aboutus">About Us</a>
        <a class="" routerLink="/contactus">Contact Us</a>
    </li>
</ul>
</section>
